export default __webpack_public_path__ + "third_stop-d50200.mp3";